import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const sleepAndRestFeaturesGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-1',
    position: [80, 40],
    opacity: 0.2,
    size: 50,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-2',
    position: [20, 90],
    opacity: 0.1,
    size: 50,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'gradient-3',
    position: [5, 5],
    opacity: 0.1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#D8CA9B',
    id: 'gradient-4',
    position: [65, 65],
    opacity: 0.1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#D8CA9B',
    id: 'gradient-5',
    position: [50, 75],
    opacity: 0.1,
    size: 20,
  },
];

export default sleepAndRestFeaturesGradients;
